import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetTokensPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/inputs/get-tokens-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterTokenListContext } from '../../token.context';
import { TokenListFilterFormStep1Controller } from '../token-list-filter-form-step-1/token-list-filter-form-step-1.controller';

export interface TokenListFilterFormControllerProps {
  onError: SubmitErrorHandler<GetTokensPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetTokensPaginatedModel>;
  onCancel: () => void;
}

export const TokenListFilterFormController = (
  props: TokenListFilterFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterTokenListContext();

  return (
    <MultiStepFormProvider<GetTokensPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      items={[
        {
          fields: ['type', 'valid'],
          component: <TokenListFilterFormStep1Controller />,
        },
      ]}
    />
  );
};
